import React, { useEffect } from 'react';
import Page from '../components/page';
import main from '../main';
import { showToast } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { getSafeLandingLink } from '../utils/landingPage';

export default function CustomerPage() {
  const navigate = useNavigate();
  const serviceLink = getSafeLandingLink(main.serviceLink);
  useEffect(() => {
    if (!serviceLink) {
      showToast('该商家很懒，没有设置接待客服');
      navigate('/' + (main.shopId ? '?code=' + main.shopId : ''));
    } else if (serviceLink.includes('work.weixin.qq')) {
      window.open(serviceLink, '_blank', 'noopener,noreferrer');

      navigate('/' + (main.shopId ? '?code=' + main.shopId : ''));
    }
  }, []); // eslint-disable-line
  let isWx = serviceLink?.includes('work.weixin.qq');
  return (
    <Page navPage className="customer-page" contentClassName="bh-100">
      {isWx ? <div /> : <iframe title="客服" className="customer-iframe" src={serviceLink} />}
    </Page>
  );
}
